module.exports = __webpack_public_path__ + "img/correct.e762bdd8.png";